/* eslint-disable react-hooks/exhaustive-deps */
import { ILanding, ILandingContent, ILandingSection, LANDING_TYPE_CONTENT, OVERLAY_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { IOfflineDataProps, OFFLINE_SECTIONS } from "../landing-edit/landing-edit-overlay/OfflineSections"
import { useEffect, useState } from "react"
import OverlayBtns from "./OverlayBtns"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"

/* Protopia Ecosystem component */
export interface IBottomOverlayProps {
   
}
const BottomOverlay = (props: IBottomOverlayProps): JSX.Element => {
    const currentLanding: ILanding  = useLandingStore((state: ILandingStore) => state.currentLanding)
    const sizes = useScreenSize()
    const [top, setTop] = useState<number>(0)
    const getAllBtns = (): IOfflineDataProps[] => {
        let btn : IOfflineDataProps[] = []
        currentLanding.sections.forEach((sec: ILandingSection) => {
            if(!sec.isHidden) {
                sec.data.forEach((data: ILandingContent) => {
                    if(!data.isHidden && OFFLINE_SECTIONS.includes(data.type)) {
                        let isDisabled: boolean = false
                        if( data.type === LANDING_TYPE_CONTENT.CONTACT_FORM ) {
                            if( !data.overlayType || data.overlayType === OVERLAY_TYPE.INLINE ) {
                                isDisabled = true
                            }
                        }
                        if( !isDisabled ) {
                            btn.push({
                                section: sec,
                                data
                            })
                        }
                    }
                })
            }
        })
        return btn 
    }
    const [btns, setBtns]           = useState<IOfflineDataProps[]>(getAllBtns())
    useEffect(() => {
        setBtns( getAllBtns() ) 
    }, [currentLanding])
    useEffect(() => { 
        setTop(() => {
            const layoutContent = document.querySelector('.layout-content')
            const _top = layoutContent?.clientHeight || 100
            return _top - 25
        })
    }, [ sizes ])
    return <div className='pe-bottom-overlay-container' style={{top}}>
        <OverlayBtns btns={btns} />
    </div>
}
export default BottomOverlay